export default "__VITE_ASSET__ZG9oIoUG__"